// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"1cc12ccc","105":"3503cc8f","390":"b7322799"}[chunkId] + ".chunk.css";
};